<template>
  <div class="public">
    <header class="pub-header w-100 bg-white p-2">
      <b-img class="d-block" src="/img/logo-full.png" fluid :alt="$t('shared.AppLogo')" />
    </header>
    <!--    <change-locale id="cl"></change-locale>-->
    <router-view></router-view>
  </div>
</template>

<script>
import {ChangeLocale} from './core'
export default {
  name: 'pub',
  components: {
    ChangeLocale
  },
  created() {
    if (localStorage.getItem('SET_ACCOUNT')) {
      this.$router.push('/dashboard')
    }
  }
}
</script>

<style scoped>
.pub-header {
  position: sticky;
  left: 0;
  top: 0;
  z-index: 1;
}
#cl {
  position: absolute;
  left: 20px;
  top: 20px;
  z-index: 1;
}
.public {
  background: #37474f;
}
</style>
